import SearchTableInput from "./SearchTableInput";

export default SearchTableInput;
